import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { globalState } from 'store/reducer';

export function useUpdateUserFormData(data) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      globalState.actions.setUserFormData({
        key: 'firstName',
        value: data.firstName,
      })
    );
  }, [data.firstName]);

  useEffect(() => {
    dispatch(
      globalState.actions.setUserFormData({
        key: 'lastName',
        value: data.lastName,
      })
    );
  }, [data.lastName]);

  useEffect(() => {
    dispatch(
      globalState.actions.setUserFormData({
        key: 'zip',
        value: data.zip,
      })
    );
  }, [data.zip]);

  useEffect(() => {
    dispatch(
      globalState.actions.setUserFormData({
        key: 'city',
        value: data.city,
      })
    );
  }, [data.city]);

  useEffect(() => {
    dispatch(
      globalState.actions.setUserFormData({
        key: 'address',
        value: data.address,
      })
    );
  }, [data.address]);

  useEffect(() => {
    dispatch(
      globalState.actions.setUserFormData({ key: 'email', value: data.email })
    );
  }, [data.email]);

  useEffect(() => {
    dispatch(
      globalState.actions.setUserFormData({ key: 'phone', value: data.phone })
    );
  }, [data.phone]);

  useEffect(() => {
    dispatch(
      globalState.actions.updatePaymentFormDataField({
        key: 'name',
        value: data.name,
      })
    );
  }, [data.name]);

  useEffect(() => {
    dispatch(
      globalState.actions.updatePaymentFormDataField({
        key: 'cardNumber',
        value: data.cardNumber,
      })
    );
    dispatch(globalState.actions.setCartType({ value: data.cardNumber }));
  }, [data.cardNumber]);

  useEffect(() => {
    dispatch(
      globalState.actions.updatePaymentFormDataField({
        key: 'expirationMonth',
        value: data.expirationMonth,
      })
    );
  }, [data.expirationMonth]);

  useEffect(() => {
    dispatch(
      globalState.actions.updatePaymentFormDataField({
        key: 'expirationYear',
        value: data.expirationYear,
      })
    );
  }, [data.expirationYear]);

  useEffect(() => {
    dispatch(
      globalState.actions.updatePaymentFormDataField({
        key: 'cvv',
        value: data.cvv,
      })
    );
  }, [data.cvv]);
}
